import { useTranslation } from "react-i18next";

interface SavedSectionToastDescriptionProps {
  onDismiss: () => void;
  onShowSection: () => void;
}

export function SavedSectionToastDescription(
  props: SavedSectionToastDescriptionProps,
) {
  const translation = useTranslation();

  return (
    <div className="space-y-2 pl-6">
      <span className="block text-sm leading-4 text-zinc-500">
        {translation.t(
          "editWorkout.workoutItemActions.saveAsSectionDescription",
        )}
      </span>
      <div className="flex items-center gap-3">
        <button
          type="button"
          className="text-sm font-medium text-zinc-500 transition-colors hover:text-zinc-950"
          onClick={props.onDismiss}
        >
          {translation.t("editWorkout.workoutItemActions.saveAsSectionDismiss")}
        </button>
        <button
          type="button"
          className="text-sm font-semibold transition-colors hover:text-zinc-700 hover:underline"
          onClick={props.onShowSection}
        >
          {translation.t("editWorkout.workoutItemActions.saveAsSectionShow")}
        </button>
      </div>
    </div>
  );
}
